import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledTopContainer = styled.div`
	position: relative;
`;

const StyledImageContainer = styled.div<{ $type: string }>`
	position: relative;
	display: flex;
	align-items: ${(props) =>
		props.$type === 'vehicle' ? 'flex-end' : 'center'};
	justify-content: center;
	width: 230px;
	height: 155px;
	margin: 5px auto 0;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 15px;
	overflow: hidden;

	${(props) =>
		props.$type === 'vehicle' &&
		css`
			padding-bottom: 22px;
		`}

	img {
		position: relative;
		z-index: 3;
	}
`;

const StyledImageBg = styled.svg<{ $gold?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	path {
		opacity: ${(props) => (props.$gold ? 0.1 : 0.02)};
		fill: ${(props) => (props.$gold ? '#FABE2C' : '#ffffff')};
		transition:
			opacity 0.3s ease,
			fill 0.3s ease;
	}
`;

// @TODO: все типы товаров, нужен enum

const StyledImage = styled.img<{ $type: string }>`
	user-select: none;
	pointer-events: none;

	${(props) =>
		props.$type === 'vehicle' &&
		css`
			width: 154px;
			height: 80px;
			margin-top: 20px;
			object-fit: contain;
		`}

	${(props) =>
		props.$type === 'realty' &&
		css`
			width: 100%;
			height: 100%;
			object-fit: cover;
		`}
`;

const StyledBottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 13px;
	padding: 17px 20px 20px;

	.name {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: color 0.3s ease;
	}
`;

const StyledCurrencyIcon = styled.div<{ $icon: string }>`
	width: 14px;
	height: 14px;
	mask-image: url(${(props) => props.$icon});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: contain;
	-webkit-mask-image: url(${(props) => props.$icon});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	transition: background-color 0.3s ease;
	background-color: #ffffff;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	.price {
		display: flex;
		align-items: center;
		gap: 6px;

		img {
			transition: filter 0.3s ease;
		}

		.img-icon {
			transition: background-color 0.3s ease;
		}

		${Text} {
			font-weight: 700;
			font-size: 14px;
			color: #ffffff;
			transition: color 0.3s ease;
		}

		.from {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledStatsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledStatsIcon = styled.div<{ $icon: string }>`
	width: 10px;
	height: 10px;
	mask-image: url(${(props) => props.$icon});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: contain;
	-webkit-mask-image: url(${(props) => props.$icon});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	transition: background-color 0.3s ease;
	background-color: #ffffff;
`;

const StyledStatContainer = styled.div<{ $active?: boolean; $hover?: boolean }>`
	display: flex;
	align-items: center;
	gap: 5px;
	transition: opacity 0.3s ease;

	${(props) =>
		props.$hover &&
		css`
			&:hover {
				opacity: 1;
			}
		`}

	opacity: ${(props) => (props.$active ? 1 : 0.5)};

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

const StyledInfoHintContainer = styled.div<{ $position: 'left' | 'right' }>`
	position: absolute;
	top: 15px;
	${(props) =>
		props.$position === 'left' &&
		css`
			left: 15px;
		`}
	${(props) =>
		props.$position === 'right' &&
		css`
			right: 15px;
		`}
`;

const StyledInfoHint = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 4px;
	height: 20px;
	padding: 0 5px;
	background-color: #ffffff;
	border-radius: 6px;
	transition: background-color 0.3s ease;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
		transition: color 0.3s ease;

		span {
			font-weight: 500;
			opacity: 0.5;
		}
	}
`;

const StyledParticipantsHint = styled(StyledInfoHint)`
	background-color: #2d70da;

	${Text} {
		color: #ffffff;
	}
`;

const StyledContainer = styled.div<{ $gold?: boolean }>`
	width: 240px;
	height: 240px;
	border-radius: 20px;
	background: ${(props) =>
		props.$gold
			? 'linear-gradient(180deg, rgba(250, 190, 44, 0.1) 0%, rgba(250, 190, 44, 0) 100%), rgba(250, 190, 44, 0.1);'
			: 'rgba(255, 255, 255, 0.05)'};
	overflow: hidden;
	transition: background-color 0.3s ease;
	cursor: pointer;
	${(props) =>
		props.$gold &&
		css`
			border: 1px solid rgba(250, 190, 44, 0.25);
		`}

	${(props) =>
		props.$gold &&
		css`
			.name {
				color: #fabe2c;
				opacity: 0.75;
			}

			.price {
				${Text}, .from {
					color: #fabe2c;
				}
			}

			${StyledCurrencyIcon}, ${StyledStatsIcon} {
				background-color: #fabe2c;
			}

			${StyledStatContainer} {
				${Text} {
					color: #fabe2c;
				}
			}
		`}

	&:hover {
		background-color: #ffffff;

		${StyledImageBg} {
			path {
				opacity: 0.05;
				fill: #000000;
			}
		}

		${StyledBottomContainer} {
			.name {
				color: #000000;
			}
		}

		${StyledInfoContainer} {
			.price {
				${StyledCurrencyIcon}, .img-icon {
					background-color: #000000;
				}

				${Text} {
					color: #000000;
				}
			}
		}

		${StyledStatContainer} {
			${StyledStatsIcon} {
				background-color: #000000;
			}

			${Text} {
				color: #000000;
			}
		}

		${StyledInfoHint}:not(${StyledParticipantsHint}) {
			background-color: #000000;

			img {
				filter: invert(100%);
			}

			${Text} {
				color: #ffffff;
			}
		}
	}
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledCurrencyIcon,
	StyledImage,
	StyledImageBg,
	StyledImageContainer,
	StyledInfoContainer,
	StyledInfoHint,
	StyledInfoHintContainer,
	StyledParticipantsHint,
	StyledStatContainer,
	StyledStatsContainer,
	StyledStatsIcon,
	StyledTopContainer,
};
